module.exports = __webpack_public_path__ + "static/media/FooterDom.37e287ee.svg";